import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useDateFormat } from '@/composables/dateFormat';
import { CabinetAction, CabinetGetter } from '@/store/cabinet/cabinet.module';
import { Cabinet } from '@/store/cabinet/cabinet.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'CabinetTable',
  components: {
    LoadingComponent,
  },
  emits: [
    'toggle',
    'show'
  ],
  props: {
    cabinetId: {
      type: Number,
    },
  },
  setup: (_, context) => {
    const store = useStore();
    const dateFormat = useDateFormat();
    const cabinets = computed<Cabinet[]>(() => store.getters[CabinetGetter.ALL]);
    const isLoading = computed(() => store.getters[CabinetGetter.STATUS] === 'init' || store.getters[CabinetGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      store.dispatch(CabinetAction.FETCH)
        .then(() => initialDataTable());
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              columnDefs: [
                { type: 'formatted-num', targets: 3 },
              ],
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const createClick = () => {
      context.emit('show', null);
    };

    const selectedClick = (id: number) => {
      context.emit('toggle', id);
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    const statusHtml = (status: number) =>
      (status < 0)
        ? '<span class="text-danger">สิ้นสุดแล้ว</span>'
        : '<span class="text-success">กำลังใช้งาน</span>';

    return {
      isLoading,
      cabinets,
      datatable,
      thaiDate,
      statusHtml,
      createClick,
      selectedClick,
    };
  },
});
